/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNotPlayableCircleS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m18.329 19.743 3.964 3.964 1.414-1.414-22-22L.293 1.707l3.964 3.964A9.959 9.959 0 0 0 2 12c0 5.523 4.477 10 10 10a9.959 9.959 0 0 0 6.329-2.257zm-5.276-5.276L9 17v-6.586zM22 12a9.953 9.953 0 0 1-1.575 5.39l-4.634-4.635 1.21-.755-5.238-3.273L6.61 3.575A9.953 9.953 0 0 1 12.001 2c5.522 0 10 4.477 10 10z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNotPlayableCircleS as NotPlayableCircleS };
